const prepareCreateData = ({ ...body }) => JSON.stringify(body);

export const registrationsDataProvider = context => {
    const basePath = '/api/v1/registration';
    return {
        create: async ({ data, ...body }) => {
            const { json } = await context.fetchJson(basePath, {
                credentials: 'include',
                method: 'POST',
                body: prepareCreateData(body),
            });

            return {
                data: { ...json },
            };
        },
        update: async ({ id }) => {
            const url = `${basePath}/confirm-email/${id}`;

            const { json } = await context.fetchJson(url, {
                credentials: 'include',
                method: 'PUT',
            });

            return {
                data: { ...json },
            };
        },
    };
};
